import { useEffect, useState } from "react";
import { IoLocation } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { messageClear, user_contact } from "../store/reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";

const Contact = () => {
  const dispatch = useDispatch();
  const { successMessage, errorMessage } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.message) {
      alert("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      dispatch(user_contact(formData));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!successMessage && !errorMessage) return;

    toast.dismiss();

    if (successMessage) {
      toast.success(successMessage);

      // ✅ Clear contact form after success
      setFormData({
        name: "",
        email: "",
        message: "",
      });
    }

    if (errorMessage) {
      toast.error(errorMessage);
    }

    // ✅ Always clear redux messages
    dispatch(messageClear());
  }, [successMessage, errorMessage]);

  return (
    <section
      id="contact"
      className="bg-gradient-to-br from-blue-950 via-blue-900 to-indigo-950 text-white pt-4"
    >
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid md:grid-cols-2 gap-12 items-start">
          {/* LEFT INFO */}
          <div>
            <div className="text-start mb-16">
              <h2 className="mt-3 text-4xl sm:text-5xl font-extrabold drop-shadow-lg">
                Emergency contact{" "}
              </h2>
              <p className="mt-4 max-w-3xl text-lg text-blue-200">
                Have questions about the reunion? We're here to help!
              </p>
            </div>

            <ul className="space-y-8">
              <li className="flex items-start">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 backdrop-blur-md">
                  <MdEmail size={22} className="text-blue-300" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold">Email</h3>
                  <p className="text-blue-200"> md.farhad0401@gmail.com</p>
                </div>
              </li>

              <li className="flex items-start">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 backdrop-blur-md">
                  <IoLocation size={22} className="text-blue-300" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold">Location</h3>
                  <p className="text-blue-200">
                    Chatkhil PG Govt. high school{" "}
                  </p>
                </div>
              </li>

              <li className="flex items-start">
                <div className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 backdrop-blur-md">
                  <FaPhoneAlt size={20} className="text-blue-300" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold">Phone</h3>
                  <p className="text-blue-200">+8801336116868</p>
                  <p className="text-blue-200">+8801336116868</p>
                </div>
              </li>
            </ul>
          </div>

          {/* RIGHT FORM */}
          <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-6 md:p-10 shadow-2xl border border-white/20">
            <h2 className="mb-6 text-2xl font-bold">Ask your question?</h2>

            <form onSubmit={handleSubmit}>
              <div className="space-y-5">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your name"
                  className="w-full rounded-lg bg-transparent border border-white/30 
                             px-4 py-3 text-white placeholder-blue-200 
                             focus:outline-none focus:border-blue-400"
                />

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your email"
                  className="w-full rounded-lg bg-transparent border border-white/30 
                             px-4 py-3 text-white placeholder-blue-200 
                             focus:outline-none focus:border-blue-400"
                />

                <textarea
                  rows="5"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Write your message..."
                  className="w-full rounded-lg bg-transparent border border-white/30 
                             px-4 py-3 text-white placeholder-blue-200 
                             focus:outline-none focus:border-blue-400"
                />

                <button
                  type="submit"
                  disabled={loading}
                  // disabled={true}
                  className="w-full rounded-full 
                             bg-gradient-to-r from-blue-500 to-indigo-600 
                             hover:from-indigo-600 hover:to-blue-700 
                             py-3 font-semibold text-white 
                             transition-all duration-300 shadow-xl 
                             disabled:opacity-60"
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="border-t border-white/10 pt-6 text-center text-sm text-blue-300">
        © PGiyan reunion 2026. All rights reserved.
      </div>
      <div className="text-center text-sm text-blue-300 pb-5">
        Made with ❤️ by your reunion committee
      </div>
    </section>
  );
};

export default Contact;
